// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.breadcrumb {
  margin-top: 1.5rem;
  margin-left: 1.5rem;
}

.breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 1.25rem;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.875rem;
}

.breadcrumb-link {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--ca-primary, #0e2e80);
  font: inherit;
  text-decoration: none;
  cursor: pointer;
}
.breadcrumb-link:hover {
  color: var(--ca-primary-dark, #0d2863);
  text-decoration: underline;
}
.breadcrumb-link:focus-visible {
  outline: 3px solid rgba(40, 80, 173, 0.25);
  outline-offset: 3px;
  border-radius: var(--ca-radius-sm, 6px);
}

.breadcrumb-link i {
  font-size: 1.25rem;
}

.breadcrumb-separator {
  color: var(--ca-text-muted, #8c96a8);
}

.breadcrumb-current {
  color: var(--ca-text-secondary, #4b5870);
  font-weight: 500;
}

.breadcrumb-current i {
  font-size: 1.25rem;
}

.data-asset-setup {
  max-width: 1440px;
  margin: 0 auto;
  padding-top: 0.25rem;
  color: var(--ca-text-primary, #172033);
}

.setup-page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1.5rem;
  margin: 0.5rem 0 1.5rem;
}
.setup-page-header h1 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: clamp(1.55rem, 2vw, 1.9rem);
  font-weight: 700;
  letter-spacing: -0.035em;
}

.eyebrow {
  margin: 0 0 0.45rem;
  color: var(--ca-primary-light, #2850ad);
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.page-description {
  max-width: 760px;
  margin: 0.55rem 0 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.94rem;
  line-height: 1.65;
}

.source-type-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  padding: 0.55rem 0.8rem;
  color: var(--ca-primary, #0e2e80);
  background: var(--ca-surface-active, #eef3ff);
  border: 1px solid rgba(40, 80, 173, 0.16);
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 700;
}

.setup-card {
  position: relative;
  overflow: hidden;
  background: var(--ca-surface, #ffffff);
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  box-shadow: var(--ca-shadow-md, 0 4px 12px rgba(7, 17, 46, 0.08));
}

.setup-stepper {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  padding: 1.4rem 1.8rem;
  background: linear-gradient(180deg, #fbfcff 0%, #f6f8fc 100%);
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
}

.stepper-item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
  color: var(--ca-text-muted, #8c96a8);
}
.stepper-item:not(:last-child)::after {
  position: absolute;
  top: 1rem;
  right: 0.9rem;
  left: 2.6rem;
  height: 1px;
  background: var(--ca-border, #dfe4ec);
  content: "";
  transform: translateX(0.5rem);
}
.stepper-item.active {
  color: var(--ca-primary, #0e2e80);
}
.stepper-item.completed {
  color: var(--ca-success, #198754);
}
.stepper-item.completed .stepper-marker {
  color: #fff;
  background: var(--ca-success, #198754);
  border-color: var(--ca-success, #198754);
}
.stepper-item.completed::after {
  background: var(--ca-success-border, #b7e3ca);
}

.stepper-marker {
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.1rem;
  height: 2.1rem;
  flex: 0 0 2.1rem;
  color: var(--ca-text-tertiary, #6f7b91);
  background: #fff;
  border: 1.5px solid var(--ca-border-dark, #c7cfdd);
  border-radius: 50%;
  font-size: 0.82rem;
  font-weight: 800;
}

.stepper-item.active .stepper-marker {
  color: #fff;
  background: var(--ca-primary, #0e2e80);
  border-color: var(--ca-primary, #0e2e80);
  box-shadow: 0 0 0 4px rgba(40, 80, 173, 0.12);
}

.stepper-copy {
  z-index: 1;
  display: flex;
  min-width: 0;
  flex-direction: column;
  padding-right: 0.35rem;
  background: transparent;
}

.stepper-title {
  color: var(--ca-text-primary, #172033);
  font-size: 0.84rem;
  font-weight: 700;
}

.stepper-item:not(.active):not(.completed) .stepper-title {
  color: var(--ca-text-secondary, #4b5870);
}

.stepper-description {
  margin-top: 0.12rem;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.72rem;
  line-height: 1.35;
}

.wizard-panel {
  padding: clamp(1.25rem, 3vw, 2.25rem);
}

.panel-heading {
  display: flex;
  align-items: flex-start;
  gap: 0.9rem;
  margin-bottom: 1.8rem;
}
.panel-heading h2 {
  margin: 0;
  font-size: 1.22rem;
  font-weight: 750;
  letter-spacing: -0.02em;
}
.panel-heading p {
  margin: 0.35rem 0 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.9rem;
  line-height: 1.55;
}

.panel-heading-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.75rem;
  height: 2.75rem;
  flex: 0 0 2.75rem;
  color: var(--ca-primary, #0e2e80);
  background: var(--ca-surface-active, #eef3ff);
  border: 1px solid rgba(40, 80, 173, 0.1);
  border-radius: var(--ca-radius-md, 8px);
  font-size: 1.15rem;
}
.panel-heading-icon.success-icon {
  color: var(--ca-success, #198754);
  background: var(--ca-success-bg, #eaf7f0);
  border-color: var(--ca-success-border, #b7e3ca);
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.35rem 1.5rem;
}

.field-group {
  min-width: 0;
}

.field-full {
  grid-column: 1/-1;
}

.form-label {
  display: block;
  margin-bottom: 0.5rem;
  color: var(--ca-text-primary, #172033);
  font-size: 0.875rem;
  font-weight: 650;
}

.required-mark {
  color: var(--ca-danger, #dc3545);
  font-weight: 800;
}

.form-control,
.form-select {
  min-height: 2.85rem;
  color: var(--ca-input-text, #172033);
  background-color: var(--ca-input-bg, #fff);
  border: 1px solid var(--ca-input-border, #dfe4ec);
  border-radius: var(--ca-radius-sm, 6px);
  font-size: 0.9rem;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.form-control::placeholder,
.form-select::placeholder {
  color: var(--ca-input-placeholder, #9aa3b2);
}
.form-control:hover:not(:disabled),
.form-select:hover:not(:disabled) {
  border-color: var(--ca-border-dark, #c7cfdd);
}
.form-control:focus,
.form-select:focus {
  border-color: var(--ca-input-focus, #2850ad);
  box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.14);
}
.form-control:disabled,
.form-select:disabled {
  color: var(--ca-disabled-text, #9aa3b2);
  background-color: var(--ca-disabled-bg, #edf0f4);
}

.field-hint,
.field-error {
  display: block;
  margin-top: 0.4rem;
  font-size: 0.78rem;
  line-height: 1.45;
}

.field-hint {
  color: var(--ca-text-muted, #8c96a8);
}

.field-error {
  color: var(--ca-danger, #dc3545);
}

.identity-note,
.import-context,
.summary-note {
  display: flex;
  align-items: flex-start;
  gap: 0.7rem;
  margin-top: 1.5rem;
  padding: 0.9rem 1rem;
  color: var(--ca-text-secondary, #4b5870);
  background: var(--ca-bg-secondary, #eef2f8);
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-md, 8px);
  font-size: 0.82rem;
  line-height: 1.55;
}
.identity-note > i,
.import-context > i,
.summary-note > i {
  margin-top: 0.1rem;
  color: var(--ca-primary-light, #2850ad);
  font-size: 1rem;
}

.wizard-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 2rem;
  padding-top: 1.35rem;
  border-top: 1px solid var(--ca-border-light, #e9edf3);
}

.wizard-actions-between {
  justify-content: space-between;
}

.action-group {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 2.65rem;
  padding: 0.65rem 1rem;
  border-radius: var(--ca-radius-sm, 6px);
  font-size: 0.875rem;
  font-weight: 650;
  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
}
.btn:focus-visible {
  outline: 3px solid rgba(40, 80, 173, 0.22);
  outline-offset: 2px;
}
.btn:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.btn-primary {
  color: #fff;
  background: var(--ca-primary, #0e2e80);
  border-color: var(--ca-primary, #0e2e80);
}
.btn-primary:hover:not(:disabled) {
  color: #fff;
  background: var(--ca-primary-dark, #0d2863);
  border-color: var(--ca-primary-dark, #0d2863);
  box-shadow: 0 4px 10px rgba(14, 46, 128, 0.18);
}

.btn-outline-primary {
  color: var(--ca-primary, #0e2e80);
  background: #fff;
  border-color: var(--ca-primary, #0e2e80);
}
.btn-outline-primary:hover:not(:disabled) {
  color: #fff;
  background: var(--ca-primary, #0e2e80);
}

.configuration-block {
  margin-top: 1.7rem;
  padding: 1.25rem;
  background: var(--ca-bg, #f5f7fb);
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-md, 8px);
}

.configuration-heading,
.table-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.15rem;
}
.configuration-heading h3,
.table-heading h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: 750;
}
.configuration-heading p,
.table-heading p {
  margin: 0.25rem 0 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.82rem;
  line-height: 1.5;
}

.required-indicator {
  flex-shrink: 0;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.75rem;
}

.input-with-action {
  position: relative;
  display: flex;
  align-items: center;
}
.input-with-action .form-control {
  padding-right: 2.8rem;
}

.visibility-button {
  position: absolute;
  right: 0.35rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.1rem;
  height: 2.1rem;
  color: var(--ca-text-secondary, #4b5870);
  background: transparent;
  border: 0;
  border-radius: 5px;
}
.visibility-button:hover {
  color: var(--ca-primary, #0e2e80);
  background: var(--ca-surface-active, #eef3ff);
}

.inline-empty-state {
  padding: 1.25rem;
  color: var(--ca-text-secondary, #4b5870);
  background: #fff;
  border: 1px dashed var(--ca-border-dark, #c7cfdd);
  border-radius: var(--ca-radius-sm, 6px);
  font-size: 0.85rem;
  text-align: center;
}

.connection-result,
.import-result {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  margin-top: 1.25rem;
  padding: 0.85rem 1rem;
  border-radius: var(--ca-radius-sm, 6px);
  font-size: 0.86rem;
  line-height: 1.5;
}
.connection-result > i,
.import-result > i {
  margin-top: 0.1rem;
  font-size: 1rem;
}

.result-success,
.import-result-success {
  color: #176b42;
  background: var(--ca-success-bg, #eaf7f0);
  border: 1px solid var(--ca-success-border, #b7e3ca);
}

.result-error,
.import-result-error {
  color: #a52834;
  background: var(--ca-danger-bg, #fdecef);
  border: 1px solid var(--ca-danger, #f3b9c0);
}

.choice-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}

.choice-card {
  display: flex;
  align-items: flex-start;
  gap: 0.9rem;
  width: 100%;
  min-height: 135px;
  padding: 1.2rem;
  color: var(--ca-text-primary, #172033);
  background: #fff;
  border: 1px solid var(--ca-border, #dfe4ec);
  border-radius: var(--ca-radius-md, 8px);
  text-align: left;
  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;
}
.choice-card:hover {
  background: var(--ca-surface-hover, #f8faff);
  border-color: var(--ca-primary-light, #2850ad);
}
.choice-card.selected {
  background: var(--ca-surface-active, #eef3ff);
  border-color: var(--ca-primary, #0e2e80);
  box-shadow: 0 0 0 2px rgba(14, 46, 128, 0.08);
}

.choice-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.65rem;
  height: 2.65rem;
  flex: 0 0 2.65rem;
  color: var(--ca-primary, #0e2e80);
  background: #dce6ff;
  border-radius: var(--ca-radius-md, 8px);
  font-size: 1.2rem;
}
.choice-icon.secondary {
  color: var(--ca-text-secondary, #4b5870);
  background: var(--ca-bg-secondary, #eef2f8);
}

.choice-content {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 0.45rem;
  padding-top: 0.1rem;
}
.choice-content strong {
  font-size: 0.95rem;
  font-weight: 750;
}
.choice-content span {
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.82rem;
  line-height: 1.55;
}

.selection-indicator {
  padding-top: 0.15rem;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 1.1rem;
}

.choice-card.selected .selection-indicator {
  color: var(--ca-primary, #0e2e80);
}

.import-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1.25rem;
}

.import-context {
  flex: 1;
  margin-top: 0;
  padding: 0.7rem 0.85rem;
}

.import-result {
  margin-bottom: 1.25rem;
}

.imported-assets-section {
  margin-top: 1.5rem;
  padding-top: 1.4rem;
  border-top: 1px solid var(--ca-border-light, #e9edf3);
}

.count-pill {
  flex-shrink: 0;
  padding: 0.35rem 0.65rem;
  color: var(--ca-primary, #0e2e80);
  background: var(--ca-surface-active, #eef3ff);
  border: 1px solid rgba(40, 80, 173, 0.13);
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 700;
}

.assets-table-wrapper {
  max-height: 390px;
  overflow: auto;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-md, 8px);
}

.assets-table {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 0.82rem;
}
.assets-table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 0.8rem 0.9rem;
  color: var(--ca-text-secondary, #4b5870);
  background: #f4f6fa;
  border-bottom: 1px solid var(--ca-border, #dfe4ec);
  font-size: 0.73rem;
  font-weight: 800;
  letter-spacing: 0.035em;
  text-transform: uppercase;
  white-space: nowrap;
}
.assets-table tbody td {
  padding: 0.85rem 0.9rem;
  border-color: var(--ca-border-light, #e9edf3);
  vertical-align: top;
}
.assets-table tbody tr:hover td {
  background: var(--ca-table-row-hover, #f7f9fd);
}
.assets-table strong {
  display: block;
  font-size: 0.82rem;
  font-weight: 700;
}

.asset-description {
  display: block;
  max-width: 300px;
  margin-top: 0.25rem;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.75rem;
  line-height: 1.45;
}

.status-pill {
  display: inline-flex;
  padding: 0.25rem 0.5rem;
  color: #176b42;
  background: var(--ca-success-bg, #eaf7f0);
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: capitalize;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0;
  overflow: hidden;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-md, 8px);
}

.summary-item {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 0.4rem;
  padding: 1rem 1.15rem;
  background: #fff;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
}
.summary-item:nth-child(odd) {
  border-right: 1px solid var(--ca-border-light, #e9edf3);
}
.summary-item strong {
  overflow-wrap: anywhere;
  font-size: 0.92rem;
  font-weight: 700;
}

.summary-item-full {
  grid-column: 1/-1;
  border-right: 0 !important;
}

.summary-label {
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.75rem;
  font-weight: 650;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.summary-url {
  word-break: break-all;
}

.summary-status {
  display: inline-flex;
  align-items: center;
  color: var(--ca-success, #198754);
}

.summary-note code {
  color: var(--ca-primary, #0e2e80);
  font-size: 0.8rem;
  font-weight: 700;
}

.section-divider-label {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  margin: 1.75rem 0 1.15rem;
  color: var(--ca-text-primary, #172033);
  font-size: 0.85rem;
  font-weight: 800;
}
.section-divider-label::after {
  height: 1px;
  flex: 1;
  background: var(--ca-border-light, #e9edf3);
  content: "";
}

.update-panel .identity-note {
  margin-top: 1.7rem;
}

.loading-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 1.2rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.85rem;
}

@media (max-width: 900px) {
  .setup-stepper {
    padding: 1.2rem;
  }
  .stepper-description {
    display: none;
  }
  .stepper-item:not(:last-child)::after {
    right: 0.3rem;
    left: 2.4rem;
  }
  .setup-page-header {
    align-items: flex-start;
  }
}
@media (max-width: 680px) {
  .asset-source-breadcrumb {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .setup-page-header {
    flex-direction: column;
    gap: 0.8rem;
  }
  .setup-stepper {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 0.45rem;
    padding: 1rem 0.65rem;
  }
  .stepper-item {
    flex-direction: column;
    gap: 0.4rem;
    text-align: center;
  }
  .stepper-marker {
    width: 1.9rem;
    height: 1.9rem;
    flex-basis: 1.9rem;
  }
  .stepper-title {
    font-size: 0.68rem;
    line-height: 1.25;
  }
  .stepper-item:not(:last-child)::after {
    top: 0.95rem;
    right: -0.15rem;
    left: calc(50% + 1.15rem);
    transform: none;
  }
  .form-grid,
  .choice-grid,
  .summary-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .summary-item,
  .summary-item:nth-child(odd) {
    border-right: 0;
  }
  .summary-item-full {
    grid-column: auto;
  }
  .configuration-block {
    padding: 1rem;
  }
  .configuration-heading,
  .table-heading {
    flex-direction: column;
  }
  .choice-card {
    min-height: 0;
    padding: 1rem;
  }
  .import-actions {
    align-items: stretch;
    flex-direction: column;
  }
  .import-actions .btn {
    align-self: flex-start;
  }
  .wizard-actions,
  .wizard-actions-between {
    align-items: stretch;
    flex-direction: column-reverse;
  }
  .wizard-actions > .btn,
  .action-group .btn {
    width: 100%;
  }
  .action-group {
    width: 100%;
    flex-direction: column-reverse;
  }
}
.qualified-name {
  max-width: 24rem;
  overflow-wrap: anywhere;
}`, "",{"version":3,"sources":["webpack://./src/app/features/shared-workflows/data-asset-capture/data-asset-capture-create-or-update/data-asset-capture-create-or-update.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,mBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,iCAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;AACF;AAAE;EACE,sCAAA;EACA,0BAAA;AAEJ;AAAE;EACE,0CAAA;EACA,mBAAA;EACA,uCAAA;AAEJ;;AACA;EACE,kBAAA;AAEF;;AACA;EACE,oCAAA;AAEF;;AACA;EACE,wCAAA;EACA,gBAAA;AAEF;;AAAA;EACE,kBAAA;AAGF;;AAAA;EACE,iBAAA;EACA,cAAA;EACA,oBAAA;EACA,sCAAA;AAGF;;AAAA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,WAAA;EACA,uBAAA;AAGF;AAFE;EACE,SAAA;EACA,sCAAA;EACA,sCAAA;EACA,gBAAA;EACA,wBAAA;AAIJ;;AAAA;EACE,mBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AAGF;;AAAA;EACE,gBAAA;EACA,mBAAA;EACA,wCAAA;EACA,kBAAA;EACA,iBAAA;AAGF;;AAAA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,uBAAA;EACA,iCAAA;EACA,6CAAA;EACA,yCAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;AAGF;;AAAA;EACE,kBAAA;EACA,gBAAA;EACA,sCAAA;EACA,iDAAA;EACA,wCAAA;EACA,iEAAA;AAGF;;AAAA;EACE,aAAA;EACA,gDAAA;EACA,sBAAA;EACA,6DAAA;EACA,wDAAA;AAGF;;AAAA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,oCAAA;AAGF;AAFE;EACE,kBAAA;EACA,SAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,6BAAA;AAIJ;AAFE;EACE,iCAAA;AAIJ;AAFE;EACE,iCAAA;AAIJ;AAHI;EACE,WAAA;EACA,sCAAA;EACA,wCAAA;AAKN;AAHI;EACE,6CAAA;AAKN;;AAAA;EACE,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,uCAAA;EACA,gBAAA;EACA,kDAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAGF;;AADA;EACE,WAAA;EACA,sCAAA;EACA,wCAAA;EACA,6CAAA;AAIF;;AADA;EACE,UAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;AAIF;;AADA;EACE,sCAAA;EACA,kBAAA;EACA,gBAAA;AAIF;;AADA;EACE,wCAAA;AAIF;;AADA;EACE,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,iBAAA;AAIF;;AADA;EACE,qCAAA;AAIF;;AADA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,qBAAA;AAIF;AAHE;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AAKJ;AAHE;EACE,mBAAA;EACA,wCAAA;EACA,iBAAA;EACA,iBAAA;AAKJ;;AADA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;EACA,6CAAA;EACA,wCAAA;EACA,uCAAA;EACA,kBAAA;AAIF;AAHE;EACE,iCAAA;EACA,yCAAA;EACA,+CAAA;AAKJ;;AADA;EACE,aAAA;EACA,gDAAA;EACA,mBAAA;AAIF;;AADA;EACE,YAAA;AAIF;;AADA;EACE,iBAAA;AAIF;;AADA;EACE,cAAA;EACA,qBAAA;EACA,sCAAA;EACA,mBAAA;EACA,gBAAA;AAIF;;AADA;EACE,gCAAA;EACA,gBAAA;AAIF;;AADA;;EAGE,mBAAA;EACA,oCAAA;EACA,0CAAA;EACA,iDAAA;EACA,uCAAA;EACA,iBAAA;EACA,0DAAA;AAGF;AAFE;;EACE,2CAAA;AAKJ;AAHE;;EACE,4CAAA;AAMJ;AAJE;;EACE,4CAAA;EACA,gDAAA;AAOJ;AALE;;EACE,uCAAA;EACA,gDAAA;AAQJ;;AAJA;;EAGE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AAMF;;AAHA;EACE,oCAAA;AAMF;;AAHA;EACE,gCAAA;AAMF;;AAHA;;;EAKE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,wCAAA;EACA,2CAAA;EACA,iDAAA;EACA,uCAAA;EACA,kBAAA;EACA,iBAAA;AAIF;AAHE;;;EACE,kBAAA;EACA,uCAAA;EACA,eAAA;AAOJ;;AAHA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,qDAAA;AAMF;;AAHA;EACE,8BAAA;AAMF;;AAHA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;AAMF;;AAHA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,uCAAA;EACA,mBAAA;EACA,gBAAA;EACA,6GAAA;AAMF;AALE;EACE,0CAAA;EACA,mBAAA;AAOJ;AALE;EACE,mBAAA;EACA,aAAA;AAOJ;;AAHA;EACE,WAAA;EACA,sCAAA;EACA,wCAAA;AAMF;AALE;EACE,WAAA;EACA,2CAAA;EACA,6CAAA;EACA,8CAAA;AAOJ;;AAHA;EACE,iCAAA;EACA,gBAAA;EACA,wCAAA;AAMF;AALE;EACE,WAAA;EACA,sCAAA;AAOJ;;AAHA;EACE,kBAAA;EACA,gBAAA;EACA,iCAAA;EACA,iDAAA;EACA,uCAAA;AAMF;;AAHA;;EAGE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,sBAAA;AAKF;AAJE;;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AAOJ;AALE;;EACE,mBAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;AAQJ;;AAJA;EACE,cAAA;EACA,oCAAA;EACA,kBAAA;AAOF;;AAJA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AAOF;AANE;EACE,qBAAA;AAQJ;;AAJA;EACE,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,wCAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;AAOF;AANE;EACE,iCAAA;EACA,6CAAA;AAQJ;;AAJA;EACE,gBAAA;EACA,wCAAA;EACA,gBAAA;EACA,iDAAA;EACA,uCAAA;EACA,kBAAA;EACA,kBAAA;AAOF;;AAJA;;EAGE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;AAMF;AALE;;EACE,kBAAA;EACA,eAAA;AAQJ;;AAJA;;EAGE,cAAA;EACA,yCAAA;EACA,mDAAA;AAMF;;AAHA;;EAGE,cAAA;EACA,wCAAA;EACA,2CAAA;AAKF;;AAFA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AAKF;;AAFA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,sCAAA;EACA,gBAAA;EACA,2CAAA;EACA,uCAAA;EACA,gBAAA;EACA,uFAAA;AAKF;AAJE;EACE,4CAAA;EACA,8CAAA;AAMJ;AAJE;EACE,6CAAA;EACA,wCAAA;EACA,6CAAA;AAMJ;;AAFA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;EACA,mBAAA;EACA,uCAAA;EACA,iBAAA;AAKF;AAJE;EACE,wCAAA;EACA,2CAAA;AAMJ;;AAFA;EACE,aAAA;EACA,OAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;AAKF;AAJE;EACE,kBAAA;EACA,gBAAA;AAMJ;AAJE;EACE,wCAAA;EACA,kBAAA;EACA,iBAAA;AAMJ;;AAFA;EACE,oBAAA;EACA,oCAAA;EACA,iBAAA;AAKF;;AAHA;EACE,iCAAA;AAMF;;AAHA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAMF;;AAHA;EACE,OAAA;EACA,aAAA;EACA,uBAAA;AAMF;;AAHA;EACE,sBAAA;AAMF;;AAHA;EACE,kBAAA;EACA,mBAAA;EACA,qDAAA;AAMF;;AAHA;EACE,cAAA;EACA,wBAAA;EACA,iCAAA;EACA,6CAAA;EACA,yCAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;AAMF;;AAHA;EACE,iBAAA;EACA,cAAA;EACA,iDAAA;EACA,uCAAA;AAMF;;AAHA;EACE,SAAA;EACA,sCAAA;EACA,kBAAA;AAMF;AALE;EACE,gBAAA;EACA,MAAA;EACA,UAAA;EACA,sBAAA;EACA,wCAAA;EACA,mBAAA;EACA,kDAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;AAOJ;AALE;EACE,uBAAA;EACA,6CAAA;EACA,mBAAA;AAOJ;AALE;EACE,8CAAA;AAOJ;AALE;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;AAOJ;;AAHA;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,iBAAA;AAMF;;AAHA;EACE,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,yCAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,0BAAA;AAMF;;AAHA;EACE,aAAA;EACA,gDAAA;EACA,MAAA;EACA,gBAAA;EACA,iDAAA;EACA,uCAAA;AAMF;;AAHA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,wDAAA;AAMF;AALE;EACE,uDAAA;AAOJ;AALE;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;AAOJ;;AAHA;EACE,iBAAA;EACA,0BAAA;AAMF;;AAHA;EACE,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AAMF;;AAHA;EACE,qBAAA;AAMF;;AAHA;EACE,oBAAA;EACA,mBAAA;EACA,iCAAA;AAMF;;AAJA;EACE,iCAAA;EACA,iBAAA;EACA,gBAAA;AAOF;;AAJA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;AAOF;AANE;EACE,WAAA;EACA,OAAA;EACA,2CAAA;EACA,WAAA;AAQJ;;AALA;EACE,kBAAA;AAQF;;AALA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,wCAAA;EACA,kBAAA;AAQF;;AALA;EACE;IACE,eAAA;EAQF;EANA;IACE,aAAA;EAQF;EANA;IACE,aAAA;IACA,YAAA;EAQF;EANA;IACE,uBAAA;EAQF;AACF;AALA;EACE;IACE,mBAAA;IACA,kBAAA;EAOF;EALA;IACE,sBAAA;IACA,WAAA;EAOF;EALA;IACE,gDAAA;IACA,YAAA;IACA,qBAAA;EAOF;EALA;IACE,sBAAA;IACA,WAAA;IACA,kBAAA;EAOF;EALA;IACE,aAAA;IACA,cAAA;IACA,kBAAA;EAOF;EALA;IACE,kBAAA;IACA,iBAAA;EAOF;EALA;IACE,YAAA;IACA,eAAA;IACA,yBAAA;IACA,eAAA;EAOF;EALA;;;IAGE,qCAAA;EAOF;EALA;;IAEE,eAAA;EAOF;EALA;IACE,iBAAA;EAOF;EALA;IACE,aAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;IACE,aAAA;IACA,aAAA;EAOF;EALA;IACE,oBAAA;IACA,sBAAA;EAOF;EALA;IACE,sBAAA;EAOF;EALA;;IAEE,oBAAA;IACA,8BAAA;EAOF;EALA;;IAEE,WAAA;EAOF;EALA;IACE,WAAA;IACA,8BAAA;EAOF;AACF;AAJA;EACE,gBAAA;EACA,uBAAA;AAMF","sourcesContent":[":host {\n  display: block;\n}\n\n.breadcrumb {\n  margin-top: 1.5rem;\n  margin-left: 1.5rem;\n}\n\n.breadcrumb-nav {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0 0 1.25rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.875rem;\n}\n\n.breadcrumb-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--ca-primary, #0e2e80);\n  font: inherit;\n  text-decoration: none;\n  cursor: pointer;\n  &:hover {\n    color: var(--ca-primary-dark, #0d2863);\n    text-decoration: underline;\n  }\n  &:focus-visible {\n    outline: 3px solid rgba(40, 80, 173, 0.25);\n    outline-offset: 3px;\n    border-radius: var(--ca-radius-sm, 6px);\n  }\n}\n.breadcrumb-link i {\n  font-size: 1.25rem;\n}\n\n.breadcrumb-separator {\n  color: var(--ca-text-muted, #8c96a8);\n}\n\n.breadcrumb-current {\n  color: var(--ca-text-secondary, #4b5870);\n  font-weight: 500;\n}\n.breadcrumb-current i {\n  font-size: 1.25rem;\n}\n\n.data-asset-setup {\n  max-width: 1440px;\n  margin: 0 auto;\n  padding-top: 0.25rem;\n  color: var(--ca-text-primary, #172033);\n}\n\n.setup-page-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1.5rem;\n  margin: 0.5rem 0 1.5rem;\n  h1 {\n    margin: 0;\n    color: var(--ca-text-primary, #172033);\n    font-size: clamp(1.55rem, 2vw, 1.9rem);\n    font-weight: 700;\n    letter-spacing: -0.035em;\n  }\n}\n\n.eyebrow {\n  margin: 0 0 0.45rem;\n  color: var(--ca-primary-light, #2850ad);\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n}\n\n.page-description {\n  max-width: 760px;\n  margin: 0.55rem 0 0;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.94rem;\n  line-height: 1.65;\n}\n\n.source-type-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-shrink: 0;\n  padding: 0.55rem 0.8rem;\n  color: var(--ca-primary, #0e2e80);\n  background: var(--ca-surface-active, #eef3ff);\n  border: 1px solid rgba(40, 80, 173, 0.16);\n  border-radius: 999px;\n  font-size: 0.78rem;\n  font-weight: 700;\n}\n\n.setup-card {\n  position: relative;\n  overflow: hidden;\n  background: var(--ca-surface, #ffffff);\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-lg, 12px);\n  box-shadow: var(--ca-shadow-md, 0 4px 12px rgba(7, 17, 46, 0.08));\n}\n\n.setup-stepper {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  padding: 1.4rem 1.8rem;\n  background: linear-gradient(180deg, #fbfcff 0%, #f6f8fc 100%);\n  border-bottom: 1px solid var(--ca-border-light, #e9edf3);\n}\n\n.stepper-item {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  min-width: 0;\n  color: var(--ca-text-muted, #8c96a8);\n  &:not(:last-child)::after {\n    position: absolute;\n    top: 1rem;\n    right: 0.9rem;\n    left: 2.6rem;\n    height: 1px;\n    background: var(--ca-border, #dfe4ec);\n    content: '';\n    transform: translateX(0.5rem);\n  }\n  &.active {\n    color: var(--ca-primary, #0e2e80);\n  }\n  &.completed {\n    color: var(--ca-success, #198754);\n    .stepper-marker {\n      color: #fff;\n      background: var(--ca-success, #198754);\n      border-color: var(--ca-success, #198754);\n    }\n    &::after {\n      background: var(--ca-success-border, #b7e3ca);\n    }\n  }\n}\n\n.stepper-marker {\n  z-index: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.1rem;\n  height: 2.1rem;\n  flex: 0 0 2.1rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  background: #fff;\n  border: 1.5px solid var(--ca-border-dark, #c7cfdd);\n  border-radius: 50%;\n  font-size: 0.82rem;\n  font-weight: 800;\n}\n.stepper-item.active .stepper-marker {\n  color: #fff;\n  background: var(--ca-primary, #0e2e80);\n  border-color: var(--ca-primary, #0e2e80);\n  box-shadow: 0 0 0 4px rgba(40, 80, 173, 0.12);\n}\n\n.stepper-copy {\n  z-index: 1;\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  padding-right: 0.35rem;\n  background: transparent;\n}\n\n.stepper-title {\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.84rem;\n  font-weight: 700;\n}\n\n.stepper-item:not(.active):not(.completed) .stepper-title {\n  color: var(--ca-text-secondary, #4b5870);\n}\n\n.stepper-description {\n  margin-top: 0.12rem;\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 0.72rem;\n  line-height: 1.35;\n}\n\n.wizard-panel {\n  padding: clamp(1.25rem, 3vw, 2.25rem);\n}\n\n.panel-heading {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.9rem;\n  margin-bottom: 1.8rem;\n  h2 {\n    margin: 0;\n    font-size: 1.22rem;\n    font-weight: 750;\n    letter-spacing: -0.02em;\n  }\n  p {\n    margin: 0.35rem 0 0;\n    color: var(--ca-text-secondary, #4b5870);\n    font-size: 0.9rem;\n    line-height: 1.55;\n  }\n}\n\n.panel-heading-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.75rem;\n  height: 2.75rem;\n  flex: 0 0 2.75rem;\n  color: var(--ca-primary, #0e2e80);\n  background: var(--ca-surface-active, #eef3ff);\n  border: 1px solid rgba(40, 80, 173, 0.1);\n  border-radius: var(--ca-radius-md, 8px);\n  font-size: 1.15rem;\n  &.success-icon {\n    color: var(--ca-success, #198754);\n    background: var(--ca-success-bg, #eaf7f0);\n    border-color: var(--ca-success-border, #b7e3ca);\n  }\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1.35rem 1.5rem;\n}\n\n.field-group {\n  min-width: 0;\n}\n\n.field-full {\n  grid-column: 1 / -1;\n}\n\n.form-label {\n  display: block;\n  margin-bottom: 0.5rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.875rem;\n  font-weight: 650;\n}\n\n.required-mark {\n  color: var(--ca-danger, #dc3545);\n  font-weight: 800;\n}\n\n.form-control,\n\n.form-select {\n  min-height: 2.85rem;\n  color: var(--ca-input-text, #172033);\n  background-color: var(--ca-input-bg, #fff);\n  border: 1px solid var(--ca-input-border, #dfe4ec);\n  border-radius: var(--ca-radius-sm, 6px);\n  font-size: 0.9rem;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  &::placeholder {\n    color: var(--ca-input-placeholder, #9aa3b2);\n  }\n  &:hover:not(:disabled) {\n    border-color: var(--ca-border-dark, #c7cfdd);\n  }\n  &:focus {\n    border-color: var(--ca-input-focus, #2850ad);\n    box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.14);\n  }\n  &:disabled {\n    color: var(--ca-disabled-text, #9aa3b2);\n    background-color: var(--ca-disabled-bg, #edf0f4);\n  }\n}\n\n.field-hint,\n\n.field-error {\n  display: block;\n  margin-top: 0.4rem;\n  font-size: 0.78rem;\n  line-height: 1.45;\n}\n\n.field-hint {\n  color: var(--ca-text-muted, #8c96a8);\n}\n\n.field-error {\n  color: var(--ca-danger, #dc3545);\n}\n\n.identity-note,\n\n.import-context,\n\n.summary-note {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.7rem;\n  margin-top: 1.5rem;\n  padding: 0.9rem 1rem;\n  color: var(--ca-text-secondary, #4b5870);\n  background: var(--ca-bg-secondary, #eef2f8);\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-md, 8px);\n  font-size: 0.82rem;\n  line-height: 1.55;\n  > i {\n    margin-top: 0.1rem;\n    color: var(--ca-primary-light, #2850ad);\n    font-size: 1rem;\n  }\n}\n\n.wizard-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  margin-top: 2rem;\n  padding-top: 1.35rem;\n  border-top: 1px solid var(--ca-border-light, #e9edf3);\n}\n\n.wizard-actions-between {\n  justify-content: space-between;\n}\n\n.action-group {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 2.65rem;\n  padding: 0.65rem 1rem;\n  border-radius: var(--ca-radius-sm, 6px);\n  font-size: 0.875rem;\n  font-weight: 650;\n  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;\n  &:focus-visible {\n    outline: 3px solid rgba(40, 80, 173, 0.22);\n    outline-offset: 2px;\n  }\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.55;\n  }\n}\n\n.btn-primary {\n  color: #fff;\n  background: var(--ca-primary, #0e2e80);\n  border-color: var(--ca-primary, #0e2e80);\n  &:hover:not(:disabled) {\n    color: #fff;\n    background: var(--ca-primary-dark, #0d2863);\n    border-color: var(--ca-primary-dark, #0d2863);\n    box-shadow: 0 4px 10px rgba(14, 46, 128, 0.18);\n  }\n}\n\n.btn-outline-primary {\n  color: var(--ca-primary, #0e2e80);\n  background: #fff;\n  border-color: var(--ca-primary, #0e2e80);\n  &:hover:not(:disabled) {\n    color: #fff;\n    background: var(--ca-primary, #0e2e80);\n  }\n}\n\n.configuration-block {\n  margin-top: 1.7rem;\n  padding: 1.25rem;\n  background: var(--ca-bg, #f5f7fb);\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-md, 8px);\n}\n\n.configuration-heading,\n\n.table-heading {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 1.15rem;\n  h3 {\n    margin: 0;\n    font-size: 1rem;\n    font-weight: 750;\n  }\n  p {\n    margin: 0.25rem 0 0;\n    color: var(--ca-text-secondary, #4b5870);\n    font-size: 0.82rem;\n    line-height: 1.5;\n  }\n}\n\n.required-indicator {\n  flex-shrink: 0;\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 0.75rem;\n}\n\n.input-with-action {\n  position: relative;\n  display: flex;\n  align-items: center;\n  .form-control {\n    padding-right: 2.8rem;\n  }\n}\n\n.visibility-button {\n  position: absolute;\n  right: 0.35rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.1rem;\n  height: 2.1rem;\n  color: var(--ca-text-secondary, #4b5870);\n  background: transparent;\n  border: 0;\n  border-radius: 5px;\n  &:hover {\n    color: var(--ca-primary, #0e2e80);\n    background: var(--ca-surface-active, #eef3ff);\n  }\n}\n\n.inline-empty-state {\n  padding: 1.25rem;\n  color: var(--ca-text-secondary, #4b5870);\n  background: #fff;\n  border: 1px dashed var(--ca-border-dark, #c7cfdd);\n  border-radius: var(--ca-radius-sm, 6px);\n  font-size: 0.85rem;\n  text-align: center;\n}\n\n.connection-result,\n\n.import-result {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.65rem;\n  margin-top: 1.25rem;\n  padding: 0.85rem 1rem;\n  border-radius: var(--ca-radius-sm, 6px);\n  font-size: 0.86rem;\n  line-height: 1.5;\n  > i {\n    margin-top: 0.1rem;\n    font-size: 1rem;\n  }\n}\n\n.result-success,\n\n.import-result-success {\n  color: #176b42;\n  background: var(--ca-success-bg, #eaf7f0);\n  border: 1px solid var(--ca-success-border, #b7e3ca);\n}\n\n.result-error,\n\n.import-result-error {\n  color: #a52834;\n  background: var(--ca-danger-bg, #fdecef);\n  border: 1px solid var(--ca-danger, #f3b9c0);\n}\n\n.choice-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1rem;\n}\n\n.choice-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.9rem;\n  width: 100%;\n  min-height: 135px;\n  padding: 1.2rem;\n  color: var(--ca-text-primary, #172033);\n  background: #fff;\n  border: 1px solid var(--ca-border, #dfe4ec);\n  border-radius: var(--ca-radius-md, 8px);\n  text-align: left;\n  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;\n  &:hover {\n    background: var(--ca-surface-hover, #f8faff);\n    border-color: var(--ca-primary-light, #2850ad);\n  }\n  &.selected {\n    background: var(--ca-surface-active, #eef3ff);\n    border-color: var(--ca-primary, #0e2e80);\n    box-shadow: 0 0 0 2px rgba(14, 46, 128, 0.08);\n  }\n}\n\n.choice-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.65rem;\n  height: 2.65rem;\n  flex: 0 0 2.65rem;\n  color: var(--ca-primary, #0e2e80);\n  background: #dce6ff;\n  border-radius: var(--ca-radius-md, 8px);\n  font-size: 1.2rem;\n  &.secondary {\n    color: var(--ca-text-secondary, #4b5870);\n    background: var(--ca-bg-secondary, #eef2f8);\n  }\n}\n\n.choice-content {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 0.45rem;\n  padding-top: 0.1rem;\n  strong {\n    font-size: 0.95rem;\n    font-weight: 750;\n  }\n  span {\n    color: var(--ca-text-secondary, #4b5870);\n    font-size: 0.82rem;\n    line-height: 1.55;\n  }\n}\n\n.selection-indicator {\n  padding-top: 0.15rem;\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 1.1rem;\n}\n.choice-card.selected .selection-indicator {\n  color: var(--ca-primary, #0e2e80);\n}\n\n.import-actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-top: 1.25rem;\n}\n\n.import-context {\n  flex: 1;\n  margin-top: 0;\n  padding: 0.7rem 0.85rem;\n}\n\n.import-result {\n  margin-bottom: 1.25rem;\n}\n\n.imported-assets-section {\n  margin-top: 1.5rem;\n  padding-top: 1.4rem;\n  border-top: 1px solid var(--ca-border-light, #e9edf3);\n}\n\n.count-pill {\n  flex-shrink: 0;\n  padding: 0.35rem 0.65rem;\n  color: var(--ca-primary, #0e2e80);\n  background: var(--ca-surface-active, #eef3ff);\n  border: 1px solid rgba(40, 80, 173, 0.13);\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n\n.assets-table-wrapper {\n  max-height: 390px;\n  overflow: auto;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-md, 8px);\n}\n\n.assets-table {\n  margin: 0;\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.82rem;\n  thead th {\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    padding: 0.8rem 0.9rem;\n    color: var(--ca-text-secondary, #4b5870);\n    background: #f4f6fa;\n    border-bottom: 1px solid var(--ca-border, #dfe4ec);\n    font-size: 0.73rem;\n    font-weight: 800;\n    letter-spacing: 0.035em;\n    text-transform: uppercase;\n    white-space: nowrap;\n  }\n  tbody td {\n    padding: 0.85rem 0.9rem;\n    border-color: var(--ca-border-light, #e9edf3);\n    vertical-align: top;\n  }\n  tbody tr:hover td {\n    background: var(--ca-table-row-hover, #f7f9fd);\n  }\n  strong {\n    display: block;\n    font-size: 0.82rem;\n    font-weight: 700;\n  }\n}\n\n.asset-description {\n  display: block;\n  max-width: 300px;\n  margin-top: 0.25rem;\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 0.75rem;\n  line-height: 1.45;\n}\n\n.status-pill {\n  display: inline-flex;\n  padding: 0.25rem 0.5rem;\n  color: #176b42;\n  background: var(--ca-success-bg, #eaf7f0);\n  border-radius: 999px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: capitalize;\n}\n\n.summary-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0;\n  overflow: hidden;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-md, 8px);\n}\n\n.summary-item {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 0.4rem;\n  padding: 1rem 1.15rem;\n  background: #fff;\n  border-bottom: 1px solid var(--ca-border-light, #e9edf3);\n  &:nth-child(odd) {\n    border-right: 1px solid var(--ca-border-light, #e9edf3);\n  }\n  strong {\n    overflow-wrap: anywhere;\n    font-size: 0.92rem;\n    font-weight: 700;\n  }\n}\n\n.summary-item-full {\n  grid-column: 1 / -1;\n  border-right: 0 !important;\n}\n\n.summary-label {\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 0.75rem;\n  font-weight: 650;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.summary-url {\n  word-break: break-all;\n}\n\n.summary-status {\n  display: inline-flex;\n  align-items: center;\n  color: var(--ca-success, #198754);\n}\n.summary-note code {\n  color: var(--ca-primary, #0e2e80);\n  font-size: 0.8rem;\n  font-weight: 700;\n}\n\n.section-divider-label {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  margin: 1.75rem 0 1.15rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.85rem;\n  font-weight: 800;\n  &::after {\n    height: 1px;\n    flex: 1;\n    background: var(--ca-border-light, #e9edf3);\n    content: '';\n  }\n}\n.update-panel .identity-note {\n  margin-top: 1.7rem;\n}\n\n.loading-overlay {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  padding: 1.2rem;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.85rem;\n}\n\n@media (max-width: 900px) {\n  .setup-stepper {\n    padding: 1.2rem;\n  }\n  .stepper-description {\n    display: none;\n  }\n  .stepper-item:not(:last-child)::after {\n    right: 0.3rem;\n    left: 2.4rem;\n  }\n  .setup-page-header {\n    align-items: flex-start;\n  }\n}\n\n@media (max-width: 680px) {\n  .asset-source-breadcrumb {\n    padding-right: 1rem;\n    padding-left: 1rem;\n  }\n  .setup-page-header {\n    flex-direction: column;\n    gap: 0.8rem;\n  }\n  .setup-stepper {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 0.45rem;\n    padding: 1rem 0.65rem;\n  }\n  .stepper-item {\n    flex-direction: column;\n    gap: 0.4rem;\n    text-align: center;\n  }\n  .stepper-marker {\n    width: 1.9rem;\n    height: 1.9rem;\n    flex-basis: 1.9rem;\n  }\n  .stepper-title {\n    font-size: 0.68rem;\n    line-height: 1.25;\n  }\n  .stepper-item:not(:last-child)::after {\n    top: 0.95rem;\n    right: -0.15rem;\n    left: calc(50% + 1.15rem);\n    transform: none;\n  }\n  .form-grid,\n  .choice-grid,\n  .summary-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .summary-item,\n  .summary-item:nth-child(odd) {\n    border-right: 0;\n  }\n  .summary-item-full {\n    grid-column: auto;\n  }\n  .configuration-block {\n    padding: 1rem;\n  }\n  .configuration-heading,\n  .table-heading {\n    flex-direction: column;\n  }\n  .choice-card {\n    min-height: 0;\n    padding: 1rem;\n  }\n  .import-actions {\n    align-items: stretch;\n    flex-direction: column;\n  }\n  .import-actions .btn {\n    align-self: flex-start;\n  }\n  .wizard-actions,\n  .wizard-actions-between {\n    align-items: stretch;\n    flex-direction: column-reverse;\n  }\n  .wizard-actions > .btn,\n  .action-group .btn {\n    width: 100%;\n  }\n  .action-group {\n    width: 100%;\n    flex-direction: column-reverse;\n  }\n}\n\n.qualified-name {\n  max-width: 24rem;\n  overflow-wrap: anywhere;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
